// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"36877f2e","239":"974a54e3","453":"4cb9f65d","667":"de0d2a63"}[chunkId] + ".chunk.js";
};